// src/components/AttendanceTable.js
import React, { useState, useEffect } from 'react';
import CustomRadioButton from '../../components/Utility/CustomRadioButton';
import './AttendanceTable.css';

const AttendanceTable = ({ students, setAttendanceArray }) => {
  const [attendanceData, setAttendanceData] = useState([]);

  useEffect(() => {
    // Initialize attendance data with default values
    const initialData = students.map(student => ({
      pass_photo: student.pass_photo,
      student_uid: student.student_uid,
      full_name: student.full_name,
      class_admitted: student.class_admitted,
      roll_no: student.roll_no,
      status: 'default'
    }));
    setAttendanceData(initialData);
  }, [students]);

  const handleStatusChange = (student_uid, newStatus) => {
    const updatedData = attendanceData.map(record =>
      record.student_uid === student_uid ? { ...record, status: newStatus } : record
    );
    setAttendanceData(updatedData);

    const updatedArray = updatedData
      .filter(record => record.status !== 'default')
      .map(record => ({
        student_uid: record.student_uid,
        date: new Date().toISOString().split('T')[0], // Get current date in YYYY-MM-DD format
        status: record.status
      }));
    setAttendanceArray(updatedArray);
  };

  const options = [
    { value: 'P', label: 'Present', className: 'present' },
    { value: 'A', label: 'Absent', className: 'absent' }
  ];

  return (
    <div className="attendance-table">
      <table>
        <thead>
          <tr>
            <th>Image</th>
            <th>Name</th>
            <th>SUID</th>
            <th>Class</th>
            <th>Roll No</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {attendanceData.map(student => (
            <tr key={student.student_uid}>
              <td><img src={student.pass_photo} alt='Student Name' className="student-photo" /></td>
              <td>{student.full_name}</td>
              <td>{student.student_uid}</td>
              <td>{student.class_admitted}</td>
              <td>{student.roll_no}</td>
              <td>
                <CustomRadioButton
                  name={`status-${student.student_uid}`}
                  options={options}
                  value={student.status}
                  onChange={e => handleStatusChange(student.student_uid, e.target.value)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AttendanceTable;
